import {
  BaseSinglePicker
} from "./chunk-UAKZWEFY.mjs";

// lib/components/date-picker/base/base-range-picker.tsx
import classNames from "classnames";
import { jsx, jsxs } from "@emotion/react/jsx-runtime";
var BaseRangePicker = ({
  value,
  onChange,
  onBlur,
  left,
  right,
  autoFix,
  ...props
}) => {
  const isStartBeforeEndError = value?.start && value?.end && props.convert(value.start) > props.convert(value.end);
  return /* @__PURE__ */ jsxs("div", { className: "field has-addons", children: [
    left,
    /* @__PURE__ */ jsx("div", { className: "control", children: /* @__PURE__ */ jsx(
      BaseSinglePicker,
      {
        ...props,
        value: value?.start,
        className: classNames({
          "is-danger": isStartBeforeEndError
        }),
        onChange: (v, e) => {
          onChange?.(
            {
              start: v,
              end: value?.end
            },
            e
          );
        },
        onBlur: (v, e) => {
          if (autoFix && isStartBeforeEndError) {
            const next = {
              start: v,
              end: v
            };
            onChange?.(next, e);
            onBlur?.(next, e);
          } else {
            onBlur?.({ start: value?.start, end: value?.end }, e);
          }
        }
      }
    ) }),
    /* @__PURE__ */ jsx("div", { className: "control", children: /* @__PURE__ */ jsx(
      "span",
      {
        className: classNames("button px-1", { "is-small": props.isSmall }),
        style: {
          pointerEvents: "none",
          background: "#F2F3F4"
        },
        children: "~"
      }
    ) }),
    /* @__PURE__ */ jsx("div", { className: "control", children: /* @__PURE__ */ jsx(
      BaseSinglePicker,
      {
        ...props,
        value: value?.end,
        min: value?.start,
        className: classNames({
          "is-danger": isStartBeforeEndError
        }),
        onChange: (v, e) => {
          onChange?.(
            {
              start: value?.start,
              end: v
            },
            e
          );
        },
        onBlur: (v, e) => {
          if (autoFix && isStartBeforeEndError) {
            const next = {
              start: v,
              end: v
            };
            onChange?.(next, e);
            onBlur?.(next, e);
          } else {
            onBlur?.({ start: value?.start, end: value?.end }, e);
          }
        }
      }
    ) }),
    right
  ] });
};

export {
  BaseRangePicker
};
